import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import api from "../lib/api";

export const SubscriptionCard = () => {
  const { i18n } = useTranslation();
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get("/subscription").then(({ data }) => setSub(data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!sub?.active) return null;

  const endDate = sub.current_period_end
    ? new Date(sub.current_period_end).toLocaleDateString(i18n.language === "en" ? "en-CA" : "fr-CA", { day: "numeric", month: "long", year: "numeric" })
    : null;

  const act = async (path, msg) => {
    setBusy(true);
    try {
      await api.post(`/subscription/${path}`);
      toast.success(msg);
      load();
    } catch {
      toast.error("Erreur");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-card border border-primary/15 rounded-lg p-7" data-testid="subscription-card">
      <h2 className="font-serif-display text-2xl flex items-center gap-3"><CreditCard size={19} strokeWidth={1.5} className="text-primary" /> Mon abonnement</h2>
      <p className="text-sm text-foreground/70 mt-4">
        Statut : <span className="text-primary font-medium" data-testid="sub-status">{sub.cancel_at_period_end ? "Se termine bientôt" : "Actif"}</span>
        {endDate && <> · {sub.cancel_at_period_end ? "Accès jusqu'au" : "Renouvellement le"} <strong>{endDate}</strong></>}
      </p>
      {sub.cancel_at_period_end ? (
        <button onClick={() => act("reactivate", "Abonnement réactivé !")} disabled={busy}
          className="mt-5 px-5 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:bg-[#16528A] transition-colors duration-200 disabled:opacity-50"
          data-testid="sub-reactivate-btn">
          Réactiver l'abonnement
        </button>
      ) : (
        <button onClick={() => act("cancel", "Abonnement annulé — accès conservé jusqu'à la fin de la période")} disabled={busy}
          className="mt-5 px-5 py-2.5 rounded-full border border-destructive/50 text-destructive text-sm hover:bg-destructive/10 transition-colors duration-200 disabled:opacity-50"
          data-testid="sub-cancel-btn">
          Annuler l'abonnement
        </button>
      )}
    </section>
  );
};
